// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"VisuallyHidden_visuallyHidden__dc6ue","focusable":"VisuallyHidden_focusable__wuH_q"};